/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain headings preserve
// legacy className behavior across existing screens.
const Heading4 = ({
  id, children, className = '', tokens, variant
}) => {
  if (!tokens) {
    return (
      <h4 className={`text-base leading-tight text-h4 font-h4 ${className}`} id={id}>
        {children}
      </h4>
    )
  }

  return (
    <div className={className} id={id}>
      <Typography block heading="h4" variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </div>
  )
}

Heading4.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({})
}

Heading4.defaultProps = {
  variant: { size: 'h4' }
}

export default Heading4
